module.exports = __webpack_public_path__ + "static/media/MHeiSungHK-UltraBold.b29d49a9.svg";